











































































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class WorkReadEditCollection extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  }) readonly collection!: Array<any>

  @Prop({
    type: Array,
    default: () => [],
  }) readonly availableSuppliers!: Array<any>

  @Prop({
    type: Object,
    default: () => ({}),
  }) readonly rootData!: any

  @Prop({
    type: String,
    default: '',
  }) readonly icon!: string

  @Prop({
    type: String,
    default: '',
  }) readonly title!: string

  interchangableData: { suppliers: Array<any>; comments: Array<any> } = {
    suppliers: [],
    comments: [],
  }

  async beforeMount() {
    const current = this.interchangableData;
    for (let i = 0; i < this.workData.length; i += 1) {
      const data = this.workData[i];
      current.suppliers.push(this.rootData.Supplier);
      current.comments.push('');
    }
    this.interchangableData = current;
    this.$emit('change', this.interchangableData);
  }

  get workData() {
    return this.collection;
  }

  dataChanged() {
    this.$emit('change', this.interchangableData);
  }
}
